import { render, staticRenderFns } from "./Solicitacoes.vue?vue&type=template&id=83256fb8&scoped=true&"
import script from "./Solicitacoes.vue?vue&type=script&lang=js&"
export * from "./Solicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./Solicitacoes.vue?vue&type=style&index=0&id=83256fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83256fb8",
  null
  
)

export default component.exports